var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { useId } from '../hooks';
import { textAreaWrapper, textAreaStyle } from './styles';
import CharacterCount from './character-count';
import AutoGrow from './auto-grow';
function TextAreaInternal(_a, ref) {
    var value = _a.value, _b = _a.inverted, inverted = _b === void 0 ? false : _b, _c = _a.autoGrow, autoGrow = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? false : _d, showCharacterCount = _a.showCharacterCount, maxLength = _a.maxLength, _e = _a.size, size = _e === void 0 ? 'medium' : _e, onFocus = _a.onFocus, onBlur = _a.onBlur, restProps = __rest(_a, ["value", "inverted", "autoGrow", "error", "showCharacterCount", "maxLength", "size", "onFocus", "onBlur"]);
    var characterCounterId = "character-count-".concat(useId());
    var _f = __read(useState(false), 2), isFocused = _f[0], setIsFocused = _f[1];
    function handleFocus(event) {
        if (onFocus) {
            onFocus(event);
        }
        setIsFocused(true);
    }
    function handleBlur(event) {
        if (onBlur) {
            onBlur(event);
        }
        setIsFocused(false);
    }
    return (_jsx(AutoGrow, __assign({}, { value: value, autoGrow: autoGrow, size: size }, { children: _jsxs("div", __assign({ css: textAreaWrapper({ isFocused: isFocused, autoGrow: autoGrow }) }, { children: [_jsx("textarea", __assign({}, restProps, (showCharacterCount && {
                    'aria-describedby': characterCounterId,
                }), { ref: ref, value: value, maxLength: maxLength, onFocus: handleFocus, onBlur: handleBlur, "aria-invalid": error, css: textAreaStyle({ hasError: !!error, inverted: inverted, size: size }) })), showCharacterCount && maxLength && (_jsx(CharacterCount, { id: characterCounterId, value: value, limit: maxLength, inverted: inverted }))] })) })));
}
export default TextAreaInternal;
